// extracted by mini-css-extract-plugin
export default {"modalBody":"AgreementModal_modalBody__QH0T9"};